/* eslint-disable tailwindcss/no-arbitrary-value */
import React, { lazy, Suspense } from 'react';
import { string, bool, shape, number } from 'prop-types';
import { Skeleton, SkeletonBlock } from '@one-thd/sui-atomic-components';
import { Hydrator } from '@thd-olt-component-react/hydrator';

import { useIsMobile } from '../../../hooks/use-is-mobile';
import { RebateProduct } from '../rebate-product/RebateProduct';

const RebateDetailsLazy = lazy(() => import(
  /* webpackChunkName: "rebateDetails" */
  '../rebate-details/RebateDetails'
));

const RebatePodPlaceholder = ({ isMobile }) => {
  return (
    <Skeleton className="sui-w-full sui-bg-primary sui-my-1 sui-p-[10px] sui-min-h-[225px] md:sui-my-2" grow>
      <SkeletonBlock
        height={isMobile ? '210px' : '225px'}
        width="100%"
        disablePadding
        aspect="wide"
        density="normal"
        data-testid="rebate-pod"
      />
    </Skeleton>
  );
};

const RebatePod = ({ rebateProduct, index }) => {
  const { isMobile } = useIsMobile();

  const {
    product = {},
    maxRebateAmountLabel = '',
    maxRebate = {},
    rebatePrograms = []
  } = rebateProduct;

  if (!product?.sku) return null;

  return (
    <Hydrator
      id={`rebate-pod-${index}`}
      className="sui-bg-primary sui-my-1 sui-p-[10px] sui-min-h-[225px] md:sui-my-2"
      placeholder={<RebatePodPlaceholder isMobile={isMobile} />}
    >
      <RebateProduct product={product} />
      {typeof window !== 'undefined'
        && (
          <Suspense fallback={<div />}>
            <RebateDetailsLazy
              maxRebateAmountLabel={maxRebateAmountLabel}
              rebatePrograms={rebatePrograms}
              maxRebate={maxRebate}
            />
          </Suspense>
        )}
    </Hydrator>
  );
};

RebatePod.displayName = 'RebatePod';

RebatePod.propTypes = {
  rebateProduct: shape({
    product: shape({
      sku: string,
    }),
    isLoading: bool
  }).isRequired,
  index: number.isRequired
};

RebatePodPlaceholder.propTypes = {
  isMobile: bool
};

RebatePodPlaceholder.defaultProps = {
  isMobile: false
};

export { RebatePod };
